import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import { ClearEcommerceObject } from 'src/types/googleAnalytics';
import { getImpressionFieldObject } from 'src/utils/googleAnalytics';
import { onProductOutOfStock } from '../modules/actions';
import {
  FEATURED_PRODUCT_VISIBILITY_NAME,
  FeaturedProductImpressionEvent,
  FeaturedProductOutOfStockEvent,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [onProductOutOfStock.type]: (_prevState, nextState, _action) => {
    const {
      products: { featuredProduct },
    } = nextState;

    if (featuredProduct?.inventoryStatus === 'out_of_stock') {
      sendGAEvent<FeaturedProductOutOfStockEvent>({
        event: 'custom_event',
        event_category: 'Featured Product',
        event_action: 'Out of stock',
        event_label: String(featuredProduct.code),
      });
    }
  },
  [visibilityTrackingActions.getSectionVisibleActionType(FEATURED_PRODUCT_VISIBILITY_NAME)]: (
    state,
  ) => {
    const product = state.products.featuredProduct!;

    sendGAEvent<ClearEcommerceObject>({
      ecommerce: null,
    });

    sendGAEvent<FeaturedProductImpressionEvent>({
      event: 'product_impressions',
      event_category: 'Featured Product',
      event_action: 'Product Impressions',
      event_label: null,
      ecommerce: {
        impressions: [getImpressionFieldObject(product, state, 1, ' - featured product')],
      },
    });
  },
};
